export const dashboardConstants = {
  campaignFilterOptions: [
    {
      id: 1,
      text: 'message.dashboardMessages.all',
      value: 'active,paused,disabled'
    },
    {
      id: 2,
      text: 'message.dashboardMessages.active',
      value: 'Active'
    },
    {
      id: 3,
      text: 'message.dashboardMessages.paused',
      value: 'Paused'
    },
    {
      id: 4,
      text: 'message.dashboardMessages.completed',
      value: 'completed'
    }
  ],
  briefFilterOptions: [
    {
      id: 1,
      text: 'message.dashboardMessages.all',
      value: null
    },
    {
      id: 2,
      text: 'message.dashboardMessages.new',
      value: 1
    },
    {
      id: 3,
      text: 'message.dashboardMessages.ongoing',
      value: 2
    },
    {
      id: 4,
      text: 'message.dashboardMessages.paused',
      value: 3
    },
    {
      id: 5,
      text: 'message.dashboardMessages.postCampaign',
      value: 4
    },
    {
      id: 6,
      text: 'message.dashboardMessages.completed',
      value: 5
    },
    {
      id: 7,
      text: 'message.dashboardMessages.draft',
      value: 6
    }
  ],
  // , { id: 5, text: "Paused (low balance)", value: "paused" }
  defaultMetricObject: {
    id: 0,
    name: '',
    aggregate: 0,
    color: '',
    isMonetary: true,
    dayWiseDataSet: [],
    loading: true
  },
  campaignDefaultMetricObject:
    {
      name: '',
      aggregate: 0,
      color: '',
      isMonetary: true,
      dayWiseDataSet: []
    },
  graphColors: ['#9ea8ad', '#5cbae6', '#b5efa7', '#6a3d9a', '#d998cb', '#f2d249'],
  metricLabelMappings: [
    {
      metric: 'Cost',
      label: 'Cost'
    },
    {
      metric: 'Impressions',
      label: 'Impressions'
    },
    {
      metric: 'Clicks',
      label: 'Clicks'
    },
    {
      metric: 'Total Sales',
      label: 'Total Sales'
    },
    {
      metric: 'Orders',
      label: 'Orders'
    },
    {
      metric: 'Cost per Orders',
      label: 'Cost per Orders'
    },
    {
      metric: 'CPC',
      label: 'Cost per Click'
    }
  ],
  metricsToSkip: ['Cost']
}

export const campaignDisableStates = {
  CampaignStartingInFuture: 1,
  CampaignEnded: 2
}

export const mediaPlanStatus = {
  draft: 'Draft',
  approved: 'Approved',
  archived: 'Archived',
  active: 'Active',
  paused: 'Paused',
  inReview: 'InReview',
  rejected: 'Rejected'
}

export const mediaPlanEffectiveStatus = {
  none: 'None',
  active: 'Active',
  paused: 'Paused',
  disabled: 'Disabled'
}

export const campaignLaunchStatus = {
  readyForExecution: 1,
  executionInProgress: 2,
  readyForLaunch: 3,
  launchComplete: 4,
  failed: 5
}

export const brandLabelMap = {
  'Sephora Collection': 1,
  'Tom Ford Beauty': 2,
  'tarte': 3,
  'Make Up For Ever': 4,
  'Fenty Beauty': 5,
  'Laura Mercier': 6,
  'Shu Uemura': 7,
  'NARS': 8,
  'Charlotte Tilbury': 9,
  'DIOR': 10
}

export const scheduleStatus = {
  UpComming: 'upcoming',
  Completed: 'completed'
}